const onPage = (page) => {
  const body = document.getElementsByTagName('body')[0];
  return body.classList.contains(page);
}

export default onPage;
